const Calendar = ({ children }) => {
    return (
        <div className="calendar">
            {children}
        </div>
    );
};

export default Calendar;
